import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { TextButton } from '../text-button/text-button';
export const FormTitle = ({ title, isBtnEnabled = true, actionLabel, onActionClick, dataTestIdBtn, dataTestIdTitle, }) => {
    const actionBtn = (React.createElement(TextButton, { onClick: onActionClick, "date-testid": dataTestIdBtn }, actionLabel));
    return (React.createElement("div", { className: "sui-flex sui-justify-between sui-items-end" },
        React.createElement(Typography, { variant: "h2", weight: "display", "data-testid": dataTestIdTitle, uppercase: true }, title),
        isBtnEnabled && actionLabel && actionBtn));
};
